module.exports = __webpack_public_path__ + "static/media/icon_partner_location.98ca4f15.svg";